/* RapidCare - site-wide motion (Motion / motion.dev).
   Subtle, premium scroll reveals + staggered grids. Respects reduced-motion,
   and fails safe (a head-script timer un-hides everything if this never runs). */
import { animate, inView } from "motion";

window.__rcMotion = true;

/* Same list the CSS uses to pre-hide elements (see .js-motion rule in rc-site.css). */
var SEL = ".rc-section-header, .rc-prod-card, .pdp-benefit, .rc-detailrow-item, " +
  ".pdp-badge, .value-item, .quote-banner, .rc-ugc-inner, .rc-footer-col, " +
  ".rc-lifestyle-overlay, .pdp-band, [data-reveal]";

if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  document.documentElement.classList.remove("js-motion");
} else {
  var EASE = [0.16, 1, 0.3, 1];
  var els = Array.prototype.slice.call(document.querySelectorAll(SEL));

  /* stagger: delay each element by its index among matching siblings in the same parent */
  els.forEach(function (el) {
    var idx = 0;
    if (el.parentElement) {
      var matches = Array.prototype.filter.call(el.parentElement.children, function (c) {
        return c.matches && c.matches(SEL);
      });
      idx = matches.indexOf(el);
    }
    el.__rvDelay = Math.min(idx < 0 ? 0 : idx, 6) * 0.04;
  });

  els.forEach(function (el) {
    inView(el, function () {
      animate(
        el,
        { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0px)"] },
        { duration: 0.5, delay: el.__rvDelay || 0, ease: EASE }
      );
      return function () {}; /* play once - don't reverse on exit */
    }, { amount: 0.15 });
  });
}
